
import * as z from 'zod';

const currentYear = new Date().getFullYear();

export const enhancedBookReportSchema = z.object({
  bookId: z.string().uuid(),
  unitsSold: z.coerce.number().int().min(0),
  grossSales: z.coerce.number().min(0),
  netSales: z.coerce.number().min(0),
  royaltyAmount: z.coerce.number().min(0),
  bookFormat: z.enum(['hardcover', 'paperback', 'ebook', 'audiobook']),
  country: z.string().min(2),
  formatId: z.string(),
  reportId: z.string().optional(),
});

export const editRoyaltyReportSchema = z.object({
  authorId: z.string().uuid({ message: 'Please select an author.' }),
  year: z.coerce.number().int().min(2000).max(currentYear),
  quarter: z.coerce.number().int().min(1).max(4),
  status: z.enum(['draft', 'published']),
  books: z.array(enhancedBookReportSchema).min(1, { message: 'Please select at least one book format.' }),
});

export type FormData = z.infer<typeof editRoyaltyReportSchema>;
